<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 4
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-4-bannerimg.gif" alt="Tech Geek Edition 4"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Tech Geek Ed. 4 explores how Apple Vision Pro and spatial computing headsets are redefining mixed reality
          across work, entertainment, and communication.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          The edition highlights mobile commerce trends, contactless payment rings, and smart payment wearables
          reflecting the rise of digital-first consumer behavior.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Next-generation health technology is showcased through devices like Withings BeamO, Owlet Dream Sock, and
          BabySat for smart health and infant monitoring.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          NVIDIA’s Jetson Orin Nano Super, Project DIGITS, and DGX Station A100 demonstrate the rapid evolution of
          generative AI and edge computing hardware.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          The edition examines the growing role of AI in mental healthcare and AI-powered tuberculosis detection in
          India.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Detailed comparisons of leading AI tools and coding assistants help users choose the right productivity and
          development platforms.
        </p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Immersive & Spatial Computing:</strong> Apple Vision Pro is leading a new generation of spatial
          computing headsets that blend digital and physical worlds for immersive mixed reality experiences.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Smart Payments & Mobile Commerce:</strong> Contactless payment rings, smart wearables, and
          accelerating m-commerce are reshaping how consumers and businesses transact digitally.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>HealthTech & Wearable Devices:</strong> Withings BeamO and Owlet Dream Sock highlight the shift toward
          proactive, connected healthcare and smart infant monitoring.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Hardware & Edge Computing:</strong> NVIDIA’s Jetson Orin Nano Super and Project DIGITS make
          high-performance generative AI more accessible through compact, scalable hardware.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI in Healthcare & Social Impact:</strong> AI-powered mental health tools and tuberculosis detection
          systems in India demonstrate how AI is improving early diagnosis and care outcomes.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Tools & Software Development:</strong> Comparisons of GitHub Copilot, ChatGPT, Claude AI,
          Perplexity AI, and Microsoft Copilot guide developers in choosing the right AI coding and testing tools.
        </p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 4.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>